import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

//import Grid          from '@common/grid/_grid';

import ContentsModal from '@partials/contents-modal';
// -------------------------------------------------------


class InsightSettingModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
      reports: [],
      update: [],
      not_targets: [],
      error_columns : { list: [], insta_error: false, url_error: false },
      is_update: false,
    };
  }
  // -------------------------------------------------------
  
  showModal(project_id, targets) {
    this.setState({ modal: true, reports: [] });
  }
  // -------------------------------------------------------
  
  closeModal() {
    if( this.state.is_update == true ){
      let chk = confirm('編集中の内容を破棄して画面を閉じてもよろしいですか？');
      if( chk == false ) return;
    }
    
    this.setState({ modal: false, targets: [], is_update: false });
  }
  // -------------------------------------------------------
  
  updateEvent(rows, columns) {
    let ids = [];
    for( let i in this.props.data.workflow.influencers ) ids.push(this.props.data.workflow.influencers[i].insta_id);
    
    let error_columns = { list: [], insta_error: false, url_error: false };
    let not_targets = [];
    rows.map((d) => {
      if( d.insta_id != undefined && ids.indexOf(d.insta_id) == -1 ){
        error_columns.insta_error = true;
        error_columns.list.push({ rowId: d.rowId, column: 'insta_id' });
        not_targets.push(d.insta_id);
      }
      if( d.post_url == undefined ){
        error_columns.url_error = true;
        error_columns.list.push({ rowId: d.rowId, column: 'post_url' });
      }
    });
    
    this.setState({ update: rows, not_targets: not_targets, error_columns: error_columns, is_update: true });
  }
  // -------------------------------------------------------
  
  saveEvent() {
    
    if( this.state.error_columns.insta_error == true ){
      let chk = confirm('プロジェクト対象外のインフルエンサーIDが登録されています。対象はレポートに反映されませんがよろしいですか？');
      if( chk == false ) return;
    }
    
    Utils.request.bind(this)('/api/project/workflow/save_report_insights', { project_id: this.props.data.project.id, mode: 'register', update: this.state.update },
      function(res){
        alert('レポートデータを登録しました！\n※反映までしばらく時間が掛かります。お待ち下さい。');
        this.setState({ modal: false, targets: [], is_update: false, preview: {} });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    let detail = base.project.detail;
    
    return (
      <div className="report-create-edit-box create">
        <div className="button" onClick={this.showModal.bind(this)}><i className="material-icons">add_circle_outline</i>レポート登録</div>
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {'calc(100% - 60px)'}
          height    = {'calc(100% - 110px)'}
          close_ev  = {this.closeModal.bind(this)}
          html      = {<ReportScoreSettingGrid reports={this.state.reports} error_columns={this.state.error_columns} update_ev={this.updateEvent.bind(this)} save_ev={this.saveEvent.bind(this)} close_ev={this.closeModal.bind(this)} />}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class ReportScoreSettingGrid extends React.Component {
  render() {
    let base = this.props.data;
    
    let parent_columns = [
      { id: 'basic',         name: '基本データ',              colspan: 2 },
      { id: 'basic',         name: 'フォロワー数',            colspan: 1 },
      { id: 'score_basic',   name: '基本スコア',              colspan: 3 },
      { id: 'score_reach',   name: 'リーチスコア',            colspan: 4 },
      { id: 'score_feed',    name: 'インプレッションスコア',  colspan: 4 },
      { id: 'score_reel',    name: 'リールスコア',            colspan: 5 },
    ];
    
    let columns = [
      { id: 'insta_id',      name: 'インスタID', parent: 'basic', type: 'text', width: 150 },
      { id: 'post_url',      name: '投稿URL',    parent: 'basic', type: 'text', width: 250 },
    ];
    Const.value.reportColumns.map((c) => { columns.push(c); });
    
    return (
      <div className="report-setting-modal">
        <h1>レポートの登録</h1>
        <h3>インフルエンサーのレポートを登録しましょう。投稿URLとインサイトスコアを入力してください。</h3>
        
        <Grid
          items             = {this.props.reports}
          parent_columns    = {parent_columns}
          columns           = {columns}
          must_columns      = {['post_url']}
          error_columns     = {this.props.error_columns.list}
          update_ev         = {this.props.update_ev.bind(this)}
          stickyLeftColumns = {3}
          stickyTopRows     = {3}
          defaultRowCount   = {100}
        />
        
        { (this.props.error_columns.url_error == true) && <p className="alert">投稿URLが未入力のカラムがあります。</p> }
        { (this.props.error_columns.insta_error == true) && <p className="alert">プロジェクト対象外のインフルエンサーIDが登録されています。対象はレポートに反映されません。</p> }
        
        <div className="yes-no">
          <div className="button" onClick={this.props.save_ev.bind(this)}>登録</div>
          <div className="button no" onClick={this.props.close_ev.bind(this)}>キャンセル</div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InsightSettingModal;